module.exports = __webpack_public_path__ + "img/alter-ego_jp.effeb3c.jpg";